import { UserResponseViewModel } from 'types/user';
import { TableFiltersState, TableParams } from 'types/common';

export type UsersTableParams = TableParams & Pick<TableFiltersState, 'activeStatus'>;

export type State = {
    isLoading: boolean;
    list: UserResponseViewModel[];
    tableParams: UsersTableParams;
    totalCount: number;
};

export const tableColumns = [
    {
        id: '1',
        field: 'isActive',
        label: 'Active',
    },
    {
        id: 'email',
        field: 'email',
        label: 'Email',
    },
    {
        id: '2',
        field: 'firstName',
        label: 'Name',
    },
    {
        id: '3',
        field: 'address',
        label: 'Address',
    },
    {
        id: '5',
        field: 'phoneNumber',
        label: 'Phone number',
    },
    {
        id: '4',
        field: 'updatedDate',
        label: 'Updated',
    },
];

export const initialUsersTableParams: TableParams = {
    sortOrder: 'asc',
    orderBy: tableColumns[0].field,
    page: 0,
    pageSize: 5,
    search: undefined,
};

export const initialState: State = {
    isLoading: true,
    list: [],
    tableParams: { ...initialUsersTableParams, activeStatus: true },
    totalCount: 0,
};
